module.exports = __webpack_public_path__ + "img/zap-off.8493c71d.svg";